<template>
  <div class="d-flex justify-content-between align-items-center">
    <div v-show="haveLink">
      <div class="d-flex align-items-center">
        <img src="@/assets/グループ登録.png" /><b class="ms-1"
          ><a
            class="link"
            style="cursor: pointer"
            @click="$emit('goGroupregistration')"
            >併合事件グループ登録</a
          ></b
        >
        <img class="ms-4" src="@/assets/CSV.png" /><b class="ms-1"
          ><a class="link" style="cursor: pointer" @click="$emit('download')"
            >CSV出力</a
          ></b
        >
      </div>
    </div>
    <div
      :class="haveLink == true ? '' : 'col-122'"
      class="d-flex justify-content-center"
    >
      <b-pagination
        v-model="currentPage"
        class="mb-0"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        @change="chagePage"
      ></b-pagination>
      <div class="search">
        <b-form-input
          v-model="pageTo"
          class="input-height"
          type="number"
          min="1"
        ></b-form-input>
      </div>
      <div class="ms-2">
        <ButtonNormal button-name="ページ指定" @click="jumpto"></ButtonNormal>
      </div>
    </div>
    <div v-if="haveLink" class="w-25" />
  </div>
</template>

<script>
import ButtonNormal from './ButtonNormal.vue'
export default {
  components: { ButtonNormal },
  props: {
    list: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 1,
      required: true
    },
    haveLink: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      currentPage: 1,
      pageTo: null
    }
  },
  computed: {
    rows() {
      return this.list.length
    }
  },
  created() {
    $(() => {
      $('.pagination').find('li').addClass('pagBtn')
    })
  },
  methods: {
    chagePage(pageNum) {
      this.$emit('onChangePage', pageNum)
    },
    jumpto() {
      if (this.pageTo != null && this.pageTo > 0) {
        this.currentPage = this.pageTo
        this.$emit('onChangePage', this.currentPage)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.col-122 {
  width: 100%;
}
.search {
  margin-left: 30px;
  width: 80px;
  .input-height {
    height: 25px;
  }
}
.but {
  margin-left: 30px;
}
button {
  background: rgb(242, 246, 255);
}
.pagination {
  --bs-pagination-active-bg: rgb(35, 78, 165);
  --bs-pagination-active-border-color: rgb(35, 78, 165);
  --bs-pagination-active-color: rgb(255, 255, 255);
  --bs-pagination-disabled-bg: rgb(225, 225, 225);
  --bs-pagination-disabled-border-color: rgb(225, 225, 225);
  --bs-pagination-disabled-color: rgb(104, 93, 93);
}
</style>
<style>
.page-link {
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px !important;
  border-radius: 0.375rem !important;
  width: 25px;
  text-align: center;
}
</style>
